import { customAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const zscaler = defineConnector({
  identifier: "zscaler",
  name: "Zscaler",
  tagLine: "Cloud security platform",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: () => "https://.*\\.zscaler[a-z]*\\.net/.*",
  auth: customAuth("zscaler"),
  steps: [
    {
      title: "Get your Zscaler API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "In the Zscaler Admin Portal, go to **Administration > API Key Management** to create or retrieve your API key and credentials.",
        },
      ],
    },
    {
      title: "Enter your Zscaler details",
      items: [
        {
          kind: "input",
          label: "Cloud name",
          required: true,
          placeholder: "zscaler",
          target: { kind: "configuration", field: "cloud" },
          helperText:
            "Your Zscaler cloud (e.g., zscaler, zscalerone, zscalertwo).",
        },
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
        {
          kind: "input",
          label: "Username",
          required: true,
          target: { kind: "configuration", field: "username" },
        },
        {
          kind: "input",
          label: "Password",
          required: true,
          target: { kind: "secrets", field: "password" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ cloud }) => `https://zsapi.${cloud}.net/api/v1/status`,
  },
});
